import { UpsertPriceComponent, upsertPriceImports } from '../upsert-price.component';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { inOutAnimation } from '../../../../animations';
import { Observable } from 'rxjs';
import { Price } from '../../../../models/price/price';
import { UpsertBlockTariffComponent } from '../pricing-list/upsert-block-tariff/upsert-block-tariff.component';

@Component({
  selector: 'psc-add-price',
  standalone: true,
  imports: [
    upsertPriceImports,
    UpsertBlockTariffComponent,
  ],
  templateUrl: '../upsert-price.component.html',
  animations: [
    inOutAnimation({}),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddPriceComponent extends UpsertPriceComponent implements OnInit {
  override ngOnInit() {
    super.ngOnInit();
  }

  get backRoute(): string {
    return '..';
  }
  protected saveToApi(): Observable<Price> {
    const price = JSON.parse(JSON.stringify(this.formGroup.value));

    this.parseFormValueProperly(price);
    return this.priceService.addPrice(price);
  }


}
